import { Typography } from "@mui/material";

const typographyStyles = {
  chartTitle: {
    fontFamily: "Poppins, sans-serif",
    fontWeight: 800,
    fontSize: { xs: 18, md: 22 },
    lineHeight: 1.25,
    color: "#111827",
  },
  tablePrimary: {
    fontFamily: "Poppins, sans-serif",
    fontWeight: 700,
    fontSize: { xs: 14, md: 15 },
    lineHeight: 1.45,
    color: "#111827",
  },
  tableSecondary: {
    fontFamily: "Poppins, sans-serif",
    fontWeight: 600,
    fontSize: { xs: 14, md: 15 },
    lineHeight: 1.45,
    color: "#263142",
  },
  tableMeta: {
    fontFamily: "Poppins, sans-serif",
    fontWeight: 700,
    fontSize: 13,
    lineHeight: 1,
    color: "#566174",
  },
  price: {
    fontFamily: "Poppins, sans-serif",
    fontWeight: 800,
    fontSize: { xs: 13, md: 14 },
    lineHeight: 1.2,
    color: "#9f0d26",
  },
  emptyState: {
    fontFamily: "Poppins, sans-serif",
    fontWeight: 700,
    fontSize: 15,
    lineHeight: 1.45,
    color: "#263142",
  },
};

export default function AppTypography({ variant = "tableSecondary", sx, ...props }) {
  return (
    <Typography
      sx={{
        ...typographyStyles[variant],
        ...sx,
      }}
      {...props}
    />
  );
}
